import { foundationSliderStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX, ColorHEX } from '../_common';
import { primaryBlueWebRGBA } from '../_config/styles';
export const zeroSliderStyles = (context, definition) => css `
  ${foundationSliderStyles(context, definition)}
  :host {
    --primary-gradient-angle: -113.5deg;
  }

  .thumb-cursor {
    background: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
    border-radius: calc(var(--control-corner-radius) * 2px);
  }

  .thumb-cursor:hover,
  .thumb-cursor:active {
    background: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
    border-radius: transparent;
  }

  :host(:focus-visible) .thumb-cursor {
    box-shadow: 0 0 0 0;
  }

  .thumb-cursor:hover::after,
  .thumb-cursor:active::after {
    content: '';
    height: calc(var(--thumb-size) * 2px);
    width: calc(var(--thumb-size) * 2px);
    border-radius: calc(var(--control-corner-radius) * 4px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }

  .thumb-cursor:hover::after {
    background-color: ${primaryBlueWebRGBA(0.1)};
  }

  .thumb-cursor:active::after {
    background-color: ${primaryBlueWebRGBA(0.2)};
  }

  .track {
    background-color: ${ColorHEX.mediumGrey};
  }

  .track-progress {
    background-color: var(--neutral-stroke-rest);
  }
`;
